import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Pendingindisburse(state = initialState, action) {
  switch (action.type) {
    case userConstants.PENDINGINDISBURSMENT_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.PENDINGINDISBURSMENT_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.PENDINGINDISBURSMENT_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}